<template>
  <BLayoutList :title="pageTitle" :skeleton="isLoadingAsyncData">
    <template #before-add>
      <BMenuMore :list="menuData" :skeleton="isLoadingAsyncData" class="mr-2" @selected="onSelectImportMenu">
        <template #activator>
          <v-btn depressed class="pr-1">
            <span>Данные</span>
            <v-divider vertical class="ml-2 mr-1" />
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
      </BMenuMore>
      <input v-show="false" ref="input" accept=".xlsx" type="file" @input="onFileChoose($event.target.files)">
    </template>

    <template #filter>
      <ComponentFilter :data="filters" :skeleton="isLoadingAsyncData" @change="onChangeFilter" />
    </template>
    <BTableCommon
      v-model="selected"
      type="passport"
      :list="list"
      :pagination="pagination"
      :ordering="filters.ordering"
      :loading="isLoading"
      :skeleton="isLoadingAsyncData"
      @change:pagination="onChangePagination"
      @change:sort="onChangeSort"
      @activate="onUpdateWithRefresh"
      @action:passport-download="onOpenModalWithId"
    />
    <v-overlay :value="prefillFileLoading">
      <v-progress-circular indeterminate size="64" />
      <span> Файл загружается...</span>
    </v-overlay>
  </BLayoutList>
</template>

<script>
import { createPassportListMixin } from '@/helpers/mixins/createPassportListMixin'
import { PassportsListModel as Model } from './Model'
import { PassportsListStoreModule as StoreModule } from './store'

import BLayoutList from '@/components/layouts/BLayoutList.vue'
import BTableCommon from '@/components/tables/BTableCommon.vue'
import ComponentFilter from './components/FormDataFilter.vue'
import BMenuMore from '@/components/common/BMenuMore.vue'
import { LkPassportApi } from '@/api/resources'
import { downloadLinkByPost } from '@/helpers/downloadBlob'
import { createPassportRefreshModal, createPassportReportModal } from './utils'

const mixinOptions = { Model, StoreModule }
const listMixin = createPassportListMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createPassportListMixin').ListMixin<any, StoreModule> } List */

const MENU_DATA = {
  DOWNLOAD_DATA: {
    id: 'download_data',
    title: 'Скачать данные',
  },
  DOWNLOAD_TEMPLATE: {
    id: 'download_template',
    title: 'Получить шаблон предзаполнения паспорта для ОО',
  },
  UPLOAD_TEMPLATE: {
    id: 'upload_template',
    title: 'Загрузить предзаполнение',
  },
  REFRESH: {
    id: 'resfresh',
    title: 'Обновить состояние',
  },
}

export default {
  name: 'PassportTemplatesList',
  components: {
    BLayoutList,
    BTableCommon,
    ComponentFilter,
    BMenuMore,
  },
  mixins: [listMixin],
  data: () => ({
    selected: [],
    menuData: Object.values(MENU_DATA),
    prefillFileLoading: false,
  }),
  methods: {
    async onSelectImportMenu(data) {
      switch (data.id) {
        case MENU_DATA.DOWNLOAD_DATA.id: {
          await this.onOpenModal()
          break
        }
        case MENU_DATA.DOWNLOAD_TEMPLATE.id: {
          await this.downloadPrefill()
          break
        }
        case MENU_DATA.UPLOAD_TEMPLATE.id: {
          await this.uploadPrefill()
          break
        }
        case MENU_DATA.REFRESH.id: {
          await this.onRefreshState()
          break
        }

        default:
      }
    },
    async onRefreshState() {
      const options = {
        on: {
          submit: () => {
            this.onChangePagination({ page: 1 })
          },
        },
      }
      const modal = await createPassportRefreshModal(this, options)
      await modal.open()
    },
    async downloadPrefill() {
      try {
        const api = new LkPassportApi()
        const url = api.downloadPrefill()
        const data = new FormData()
        data.append('ate_type', this.filters.passport_type)
        await downloadLinkByPost(
          url,
          data,
          'Шаблон предзаполнения.xlsx',
        )
      } catch (e) {
        this.$notice.errors(e)
      }
    },
    uploadPrefill() {
      this.$refs.input.click()
    },
    async onFileChoose(files) {
      this.prefillFileLoading = true
      const api = new LkPassportApi()
      const [file] = files
      try {
        await api.uploadPrefill(file, this.filters.passport_type)
        this.prefillFileLoading = false
        this.$notice.create({
          type: 'success',
          text: 'Задача выполнена. Результат работы отображен в уведомлениях.',
        })
      } catch (e) {
        this.prefillFileLoading = false
        if (e.response && e.response.status === 504) {
          this.$notice.create({
            type: 'success',
            text: 'Задача запущена. Результат работы будет отображен в уведомлениях.',
          })
        } else {
          this.$notice.errors(e)
        }
      } finally {
        this.prefillFileLoading = false
        this.$refs.input.value = null
      }
    },
    async onOpenModal() {
      const requestParams = {
        ...this.filters,
        login: this.filters?.search,
      }
      delete requestParams.search
      const propsData = {
        params: { isList: true },
        requestParams,
        title: 'Отчет',
      }
      const modal = await createPassportReportModal(this, propsData)
      await modal.open()
    },
    async onOpenModalWithId(data) {
      const propsData = {
        params: { isList: false, passportId: data.id },
        title: 'Отчет',
      }
      const modal = await createPassportReportModal(this, propsData)
      await modal.open()
    },
  },
}
</script>
